import {
  loadCoachSessionSettings,
  saveCoachSessionSettings,
} from "./liveTrainingSettings";

/**
 * @deprecated Prefer loadCoachSessionSettings / saveCoachSessionSettings.
 * Kept for Training.jsx and older call sites.
 */
export function readAutoAdvanceSequences(tsId) {
  return loadCoachSessionSettings(tsId).autoAdvanceSequences === true;
}

export function writeAutoAdvanceSequences(tsId, enabled) {
  const current = loadCoachSessionSettings(tsId);
  saveCoachSessionSettings(tsId, {
    ...current,
    autoAdvanceSequences: !!enabled,
  });
}
